module.exports = __webpack_public_path__ + "static/media/arrow_down.d55b9ea0.svg";